import { render, staticRenderFns } from "./SideBarEntry.vue?vue&type=template&id=fe0ccaba&"
import script from "./SideBarEntry.vue?vue&type=script&lang=js&"
export * from "./SideBarEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports